import styled from '@emotion/styled'
import { Link, LinkIcon } from '~/components/Link'

export const SortLink = styled(Link)<{ open: boolean }>`
  ${LinkIcon} {
    transition: 0.25s;
    transform: rotate(${(props) => (props.open ? '-180deg' : '0')});
  }
`
